import React from 'react'
import ScholarshipTemplate from 'components/templates/ScholarshipTemplate'
import Typography from 'components/atoms/Typography'
import Button from 'components/atoms/Button'
import { Image, Container, Row, Col } from 'components/qstrap'

class Winners extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      winners: [],
    }
  }

  async componentDidMount() {
    const response = await fetch('/qsc/winners.json')
    const json = await response.json()
    this.setState({ winners: json })
  }

  render() {
    const { path } = this.props.match

    return (
      <ScholarshipTemplate path={path}>
        <div id="ScholarshipWinner">
          <div className="top-info">
            <Container>
              <Col md="6">
                <Typography variant="big" className="bold" component="h1">
                  Ini dia total 150 siswa siswa terpilih menjadi penerima beasiswa penuh dari President University
                </Typography>
                <Image src="/assets/img/scholarship/qsc-w-top.png" className="top-info-img m-b-lg" />
              </Col>
              <Col md="6">
                <Typography variant="subheading" component="div">
                  <p>Terima kasih kepada seluruh siswa yang telah antusias dan berpartisipasi dalam Quipper Scholarship Challenge 2018. Bagi kamu yang belum berhasil meraih beasiswa penuh dari President University, jangan bersedih, masih ada peluang mendapat beasiswa parsial dan akan mendapat email langsung dari pihak President University mengenai info beasiswa.</p>
                  <p>Pengiriman LoA (Letter of Acceptance) kepada siswa yang lulus QSC 2018 telah dilakukan oleh pihak President University pada tanggal 17 Januari 2019, kalau ada pertanyaan  siswa mengenai kabar LoA dari President University, dapat langsung di DM ke Instagram <b>@joinpresuniv</b> atau menghubungi call center President University di <b>021-89109762 / 021-89109763</b>.</p>
                </Typography>
              </Col>
            </Container>
          </div>

          <div className="winners-container text-center">
            <Container>
              <h1>Pemenang Quipper Scholarship Challenge 2018</h1>
              <table className="winners-table">
                <thead>
                  <tr>
                    <td>No.</td>
                    <td>Nama</td>
                    <td>Kota</td>
                    <td>Jurusan</td>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.winners.map((datum, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{datum.name}</td>
                        <td>{datum.location}</td>
                        <td>{datum.study_field}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </Container>
          </div>

          <Container>
            <Row className="bottom-info">
              <Col md="6">
                <Typography variant="subheading" component="div">
                  Selamat melanjutkan pendidikan ke kampus impian, semoga dapat menyelesaikan studi secepatnya dengan hasil terbaik dan mencapai cita-cita yang telah lama diimpikan.
                </Typography>

                <Button component="a" href="/directory/president-university" className="m-t-lg" target="_blank">
                  Info Selengkapnya
                </Button>
              </Col>
              <Col md="6" className="hidden-md-down">
                <Image src="/assets/img/scholarship/qsc-w-bottom.png" className="bottom-info-img"/>
              </Col>
            </Row>
          </Container>
        </div>
      </ScholarshipTemplate>
    )
  }
}

export default Winners
